import ApiService from '../api.services';

const BoundaryService = {
  list: async function () {
    try {
      const response = await ApiService.get(`/api/boundary/capital`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default BoundaryService;

export { BoundaryService };

